export enum BrowserEnum {
    GoogleChrome = "Chrome",
    MicrosoftEdge = "Edge",
    MozillaFirefox = "Firefox",
    Opera = "Opera",
    Safari = "Safari",
    Brave = "Brave",
    InternetExplorer = "Internet Explorer"
}